<div class="centered">
  <div class="content">
    <h3 class="u-margin-bottom">
      Die angegebene Seite "{{ accessedRoute }}" existiert nicht.
    </h3>
    <button matButton (click)="returnToPageBefore()">Zurück</button>
  </div>
</div>
